import React from 'react';
import { useOutletContext } from 'react-router-dom';
import { Card, SectionTitle } from '../ui';
import { DesignOptions } from '../DesignChooser';

export default function DesignPreference() {
  const { design, setDesign } = useOutletContext();
  const pick = (t) => { if (t === design) return; setDesign(t); };
  return (
    <Card className="p-8 mt-4" data-testid="design-preference">
      <SectionTitle>Grafica del portale</SectionTitle>
      <p className="text-sm text-[#8A8F97] mb-6">Scegli l'aspetto del portale. La scelta viene salvata sul tuo profilo e vale su ogni dispositivo.</p>
      <div className="max-w-3xl"><DesignOptions value={design} onChange={pick} /></div>
    </Card>
  );
}
